module.exports = __webpack_public_path__ + "media/images/m-logo-fbeba9584dbd1a94ad25b0d62cfb0ad2.png";